import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BaseInterface,
  ChangePasswordForm,
  CreateUserPassword,
  DeactivateUserForm,
  ForgotPassword,
  LoginFromData,
  ResetPassword,
  SignupForm,
  SocialAuthProvidersFrom,
  UserDetails,
  UserDetailsResponse,
  UserLoginResponse,
  VerifyEmailOTP,
} from 'src/app/shared/models';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthServiceAris {
  constructor(private http: HttpClient) {}

  signUp(data: SignupForm) {
    return this.http.post<BaseInterface>(
      environment.baseUrl + 'Auth/Register',
      data
    );
  }

  forgotPassword(data: ForgotPassword) {
    return this.http.post<BaseInterface>(
      environment.baseUrl + 'Auth/ForgotPassword',
      data
    );
  }

  resetPassword(data: ResetPassword) {
    return this.http.post<BaseInterface>(
      environment.baseUrl + 'Auth/ResetPassword',
      data
    );
  }
  login(data: LoginFromData) {
    return this.http.post<UserLoginResponse>(
      environment.baseUrl + 'Auth/Login',
      data
    );
  }

  getUser() {
    return this.http.get<UserDetailsResponse>(
      environment.baseUrl + 'Account/GetMyProfile'
    );
  }

  verifyUserEmailOtp(data: VerifyEmailOTP) {
    return this.http.post<BaseInterface>(
      `${environment.baseUrl}Auth/TwoStepVerification`,
      data
    );
  }

  updateUserProfileDetails(data: UserDetails) {
    return this.http.post<BaseInterface>(
      environment.baseUrl + 'Account/UpdateProfile',
      data
    );
  }
 

  updateUserProfileImage(data: File) {
    const formData = new FormData();
    formData.append('profilePicture', data);
    return this.http.post<BaseInterface>(
      environment.baseUrl + 'Account/UpdateProfileImage',
      formData,
      {
        headers: {
          Accept: '*/*',
        },
      }
    );
  }

  deleteUserProfileImage() {
    return this.http.delete<BaseInterface>(
      environment.baseUrl + 'Account/DeleteProfileImage'
    );
  }

  deactivateUser(data: DeactivateUserForm) {
    return this.http.put<BaseInterface>(
      environment.baseUrl + 'Account/DeleteAccount',
      data
    );
  }

  resendEmailConfirmation(data: string) {
    return this.http.get<BaseInterface>(
      `${environment.baseUrl}Auth/ResendEmailConfirmation/?email=${data}`
    );
  }

  createUserPassword(data: CreateUserPassword) {
    return this.http.post<BaseInterface>(
      environment.baseUrl + 'Account/CreatePassword',
      data
    );
  }

  changePassword(data: ChangePasswordForm) {
    return this.http.post<BaseInterface>(
      environment.baseUrl + 'Account/ChangePassword',
      data
    );
  }

  socialAuthentication(data: SocialAuthProvidersFrom) {
    return this.http.post<BaseInterface>(
      environment.baseUrl + 'Auth/social-login',
      data
    );
  }

  checkEmailExists(email: string) {
    return this.http.get<BaseInterface>(
      `${environment.baseUrl}Auth/CheckEmail?email=${email}`
    );
  }
}
